module.exports = __webpack_public_path__ + "static/media/3.5b9ffde2.png";


//////////////////
// WEBPACK FOOTER
// ./src/emoji/3.png
// module id = 221
// module chunks = 0